/* global JsCallbackToHarmony */
(function(w) {
    ENV();
    let harmony = {};
    harmony.navigateTo = function({ url = ''} = {}) {
        if(!url) {
            console.warn('url parameter error!')
            return false;
        }
        return callMethods({methodName: 'navigateTo', params: {url}})
    }

    harmony.navigateBack = function() {
        return callMethods({methodName: 'navigateBack', params: {}})
    }

    harmony.redirectTo = function({ url = "" } = {}) {
        if(!url) {
            console.warn('url parameter error!')
            return false;
        }
        return callMethods({methodName: 'redirectTo', params: {url}})
    }

    w.harmony = harmony;
    function ENV() {
        if(!w.JsCallbackToHarmony) {
            console.warn('Please open in Harmony App!');
            return false;
        } return true;
    }
    function callMethods({methodName = "", params = {}} = {}) {
        if (!ENV()) throw new Error('ENV Error');
        const data = {
            name: methodName,
            data: params
        }
        const dataString = JSON.stringify(data)
        return w.JsCallbackToHarmony.call(dataString)
    }
})(window);



// WEBPACK FOOTER //
// ./node_modules/@kkmh/harmony-sdk/src/index.js